import { render } from "./VideoCard.vue?vue&type=template&id=2f0c9bc9&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=2f0c9bc9&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0c9bc9"]])

export default __exports__